import { alertsActions, bookingInfoActions, ticketActions } from '.';
import { curBookingsConstants } from 'store/constants';
import Bookings from 'store/models/bookings/Bookings';
import {
  bookingErrorStatuses,
  BookingI,
} from 'store/models/bookings/Booking';
import {
  curBookingsBookingsSelector,
  curBookingsSelector,
} from 'store/selectors/cur-bookings.selector';
import { commonPagesSelector } from 'store/selectors/cur-bookings-attachments.selector';
import {
  ticketBookingNosFromEmailSelector,
  ticketFormTicketSelector,
} from 'store/selectors/ticket.selector';
import { availableOnlyAttachmentsWithThumbnailSelector } from 'store/selectors/ticket-attachment.selector';
import { CommonPagesI } from 'store/models/file-selected/CommonPages';
import { bookingIdToFoundAndNotCanceledSelector } from 'store/selectors/booking-info.selector';
import { ApiAttachment } from 'store/models/MainFiles';
import { EachFileSelected } from 'store/models/file-selected/file-selected.interface';

const updateFileSelectedAtViewingIndex = (
  fileSelected: EachFileSelected[],
) => {
  return {
    type: curBookingsConstants.UPDATE_FILE_SELECTED_AT_VIEWING_INDEX,
    payload: {
      fileSelected,
    },
  };
};

const setViewingBookingIndex = (index) => {
  return {
    type: curBookingsConstants.SET_VIEWING_INDEX,
    payload: {
      index,
    },
  };
};

/**
 *
 * @param bookings
 */
const initCurBookings = (
  bookings: BookingI[] | undefined,
  attachments?: ApiAttachment[],
) => {
  const bookingsForInitCurBookings = Bookings.getInitCurBookings(
    bookings,
    attachments,
  );
  return {
    type: curBookingsConstants.INIT_CUR_BOOKINGS,
    payload: {
      bookings: bookingsForInitCurBookings,
    },
  };
};

const initCommonPages = (commonPages: CommonPagesI) => {
  return {
    type: curBookingsConstants.INIT_COMMON_PAGES,
    payload: {
      commonPages,
    },
  };
};

const addMultipleBookings = (
  num: number,
  replaceOldBookings = false,
  isSelectedAll?: boolean,
) => {
  return (dispatch, getState): Bookings => {
    const bookings = curBookingsBookingsSelector(getState());
    const attachments = availableOnlyAttachmentsWithThumbnailSelector(
      getState(),
    );
    const ticketFormData = ticketFormTicketSelector(getState());
    const commonPages = commonPagesSelector(getState());
    const newBookingsM = new Bookings(
      bookings,
      true,
    ).addNewBookingsByNum(
      num,
      replaceOldBookings,
      attachments,
      commonPages,
      ticketFormData?.bookingNo,
      ticketFormData?.isSplit,
      isSelectedAll,
    ) as Bookings;
    console.debug(`newBookingsM.bookings: `, newBookingsM.bookings);
    dispatch(setViewingBookingIndex(null));
    // dispatch(initCurBookings(newBookingsM.bookings));
    dispatch(setCurBookings(newBookingsM.bookings));
    return newBookingsM;
  };
};

const useAllBookingsFromEmail = (
  validate: boolean,
  isSelectedAll?: boolean,
) => {
  return async (dispatch, getState): Promise<Bookings> => {
    console.group('useAllBookingsFromEmail');

    const attachments = availableOnlyAttachmentsWithThumbnailSelector(
      getState(),
    );
    const bookingNos = ticketBookingNosFromEmailSelector(getState());
    const commonPages = commonPagesSelector(getState());
    const newBookingsM = new Bookings([], true).addNewBookings(
      bookingNos,
      true,
      attachments,
      commonPages,
      isSelectedAll,
    ) as Bookings;
    dispatch(setViewingBookingIndex(null));
    // dispatch(initCurBookings(newBookingsM.bookings));
    dispatch(setCurBookings(newBookingsM.bookings));

    // // ********** related to booking/info **********
    if (validate) {
      dispatch(ticketActions.setCheckingBookingInfo(true));
      await dispatch(validateAllCurBookings());
      dispatch(ticketActions.setCheckingBookingInfo(false));
    }

    // go back to update the top booking no acccordingly -> for the index 0
    // only if is single booking
    const newBookingNo = bookingNos.length === 1 ? bookingNos[0] : '';
    dispatch(
      curBookingsActions.checkBottomBookingNoAndUpdateTop(
        newBookingNo,
      ),
    );

    console.groupEnd();
    return newBookingsM;
  };
};

/**
 * set only, no direct side effect
 * @param bookings
 * @returns
 */
const setCurBookings = (bookings) => {
  return {
    type: curBookingsConstants.SET_CUR_BOOKINGS,
    payload: {
      bookings,
    },
  };
};
const addBookingNoIsRequiredErrorToBookings = (indexes: number[]) => {
  return (dispatch, getState) => {
    const oldBookings = curBookingsBookingsSelector(getState());
    const bookings = new Bookings(oldBookings).markHasErrorToIndexes(
      'bookingNoIsRequired',
      indexes,
    ) as BookingI[];
    dispatch(setCurBookings(bookings));
  };
};

/**
 * either way cause the rerendering of BookingNoInput
 * @param index
 * @param bookingNo
 */
const updateBookingNoAtIndex = (
  index,
  bookingNo,
  checkAndSyncToTopLeft = true,
) => {
  const _update = (index, bookingNo) => {
    return {
      type: curBookingsConstants.UPDATE_BOOKING_NO_AT_INDEX,
      payload: {
        index,
        bookingNo,
      },
    };
  };
  return (dispatch, getState) => {
    dispatch(_update(index, bookingNo));
    // sync with the top
    if (checkAndSyncToTopLeft && index === 0) {
      dispatch(checkBottomBookingNoAndUpdateTop(bookingNo));
    }
  };
};

const checkBottomBookingNoAndUpdateTop = (
  bottomBookingNo: string,
) => {
  return async (dispatch, getState) => {
    const formTicket = ticketFormTicketSelector(getState());
    console.debug(
      'calling checkBottomBookingNoAndUpdateTop',
      'formTicket.bookingNo',
      formTicket?.bookingNo,
      'bottomBookingNo',
      bottomBookingNo,
    );
    if (formTicket && formTicket.bookingNo !== bottomBookingNo) {
      if (
        bottomBookingNo === '' ||
        bottomBookingNo === undefined ||
        bottomBookingNo === null
      ) {
        dispatch(ticketActions.clearTopLeftBookingNo());
      } else {
        // update top left with bottom
        await dispatch(
          ticketActions.updateFormTicketAtKey(
            'bookingNo',
            bottomBookingNo,
          ),
        );
      }
    }
  };
};

/**
 * one of the calls is from onBlur main booking no input
 * TODO: combine with updateBookingNoAtIndex
 * @param index
 * @param value
 */
const updateBookingNoAtIndexAndValidate = (
  index,
  value,
  checkFoundAndCancel = false,
  checkAndSyncToTopLeft = true,
) => {
  return async (dispatch, getState) => {
    const oldBookings0 = curBookingsBookingsSelector(getState());
    const oldBookingNoAtIndex = oldBookings0[index].bookingNo;
    // call sync to top left
    dispatch(
      updateBookingNoAtIndex(index, value, checkAndSyncToTopLeft),
    );
    const oldBookings1 = curBookingsBookingsSelector(getState());
    const oldBookings1M = new Bookings(oldBookings1, true);
    let updatedBookings = oldBookings1M.updateBookingNoAtIndex(
      value,
      index,
    ) as Bookings;
    // because we don't fetch booking info on blur. if user changes the value it shouldnt still show the error so will reset first
    updatedBookings = updatedBookings.clearErrorsAtIndex(
      ['bookingIsCanceled', 'bookingNoNotFound'],
      index,
    ) as Bookings;
    // important to set the update first before validate
    dispatch(setCurBookings(updatedBookings.bookings));

    dispatch(
      validateBookingNoAtIndex(
        index,
        checkFoundAndCancel,
        oldBookingNoAtIndex,
      ),
    );

    // sync with top only when there is one booking
    const firstBookingNo =
      index === 0 && updatedBookings.length === 1
        ? updatedBookings.bookingNos[0]
        : '';
    dispatch(checkBottomBookingNoAndUpdateTop(firstBookingNo));
  };
};

/**
 * return foundMap
 * @param bookingNo
 * @param index
 */
const fetchBookingInfoIfNeeded = (
  bookingNos: string[],
  indexes?: number[], // if is [-1], it is needed
) => {
  return async (dispatch, getState) => {
    console.group('fetchBookingInfoIfNeeded');
    // found map to start
    let foundMap = bookingIdToFoundAndNotCanceledSelector(getState());
    console.debug(`fetchBookingInfoIfNeeded foundMap: `, foundMap);

    // fetch booking info for the value
    if (bookingNos && bookingNos.length > 0) {
      await dispatch(
        bookingInfoActions.getBookingInfosIfNotFetched(
          bookingNos,
          indexes,
        ),
      );
      // update
      foundMap = bookingIdToFoundAndNotCanceledSelector(getState());
    }
    console.groupEnd();
    return foundMap;
  };
};

const validateBookingNoAtIndex = (
  index: number,
  checkFoundAndCancel: boolean,
  oldBookingNoAtIndex?: string,
) => {
  return async (dispatch, getState) => {
    const bookings = curBookingsBookingsSelector(getState());
    if (!bookings.length) return;
    console.group('validateBookingNoAtIndex');

    const bookingsM = new Bookings(bookings, true);

    const booking = bookingsM.getBookingAtIndex(index);
    const value = booking.bookingNo;

    let foundMap;

    if (checkFoundAndCancel) {
      // found map to start
      dispatch(ticketActions.setCheckingBookingInfo(true));
      foundMap = await dispatch(
        fetchBookingInfoIfNeeded([value], [index]),
      );
      dispatch(ticketActions.setCheckingBookingInfo(false));
    }

    const newBookings = bookingsM.validateBookingNoAtIndexAndAddErrorStatus(
      index,
      false, // don't skip reset has dup errors at other indexes
      oldBookingNoAtIndex,
      foundMap,
    ) as Bookings;
    dispatch(setCurBookings(newBookings.bookings));

    console.groupEnd();
  };
};

/**
 * TODO: consider creating its own reducer for this
 * @param index
 * @param checked
 */
const toggleSelectBooking = (index: number, checked: boolean) => {
  return (dispatch, getState): Bookings => {
    const oldBookings = getState().curBookings.bookings;
    const bookingsM = new Bookings(
      oldBookings,
      true,
    ).markIsSelectedAtIndex(index, checked) as Bookings;
    dispatch(setCurBookings(bookingsM.bookings));
    return bookingsM;
  };
};

/**
 * TODO: consider creating its own reducer for this
 * @param index
 * @param checked
 */
const toggleSelectAllBookings = (checked: boolean) => {
  return (dispatch, getState) => {
    const oldBookings = getState().curBookings.bookings;
    dispatch(
      setCurBookings(
        oldBookings.map((b) => ({ ...b, isSelected: checked })),
      ),
    );
  };
};

const removeBookingAtIndex = (index: number) => {
  return (dispatch, getState): Bookings => {
    const oldBookings = getState().curBookings.bookings;
    if (index > oldBookings.length - 1)
      throw Error(
        `invalid index to remove. last valid index is ${
          oldBookings.length - 1
        }`,
      );
    const newBookings = new Bookings(
      oldBookings,
      true,
    ).removeBookingsAtIndexs([index]) as Bookings;
    console.log(
      `after removeBookingAtIndex`,
      newBookings,
      'oldBookings',
      oldBookings,
    );

    dispatch(setCurBookings(newBookings.bookings));

    const isSingle = newBookings.isSingle();
    if (isSingle) {
      const bookingNo = newBookings.getFirstBookingNo() as string;
      dispatch(checkBottomBookingNoAndUpdateTop(bookingNo));
    }

    // TODO: commbine with the function to remove in the removeSelectedBookings
    const { viewingIndex } = curBookingsSelector(getState());
    if (viewingIndex > newBookings.length - 1) {
      dispatch(setViewingBookingIndex(null));
    }
    return newBookings;
  };
};

const removeSelectedBookings = () => {
  return (dispatch, getState): Bookings => {
    const oldBookings = getState().curBookings.bookings;
    const newBookings = new Bookings(
      oldBookings,
      true,
    ).removeSelectedBookings() as Bookings;
    dispatch(setCurBookings(newBookings.bookings));
    // TODO: commbine with the function to remove in the removeSelectedBookings
    const { viewingIndex } = curBookingsSelector(getState());
    if (viewingIndex > newBookings.length - 1) {
      dispatch(setViewingBookingIndex(null));
    }
    return newBookings;
  };
};

/**
 * add new booking
 * auto select the existing one if already existed
 * @param bookingNo
 * @param autoSetViewingIndex
 */
const addNewBookingNo = (
  bookingNo: string,
  autoSetViewingIndex = true,
) => {
  return (dispatch, getState): boolean => {
    if (!bookingNo) {
      dispatch(
        alertsActions.error(bookingErrorStatuses.bookingNoIsRequired),
      );
      return false;
    }
    const bookings = getState().curBookings.bookings;
    const attachments = availableOnlyAttachmentsWithThumbnailSelector(
      getState(),
    );
    // check if the first one is empty -> if empty -> dispatch error
    const bookingsM = new Bookings(bookings);

    if (bookingsM.isBookingNoMatchExisting(bookingNo)) {
      // do not add if already exist
      dispatch(
        alertsActions.error(
          `Booking no ${bookingNo} already existed. Switching to that booking now.`,
        ),
      );

      if (autoSetViewingIndex) {
        // auto select that one
        const index = bookingsM.getIndexOfBookingNo(bookingNo);
        if (index > -1) dispatch(setViewingBookingIndex(index));
      }
    } else {
      const commonPages = commonPagesSelector(getState());
      const newBookings = bookingsM.addNewBookings(
        [bookingNo],
        false,
        attachments,
        commonPages,
      ) as BookingI[];
      // TODO: commbine with the function to remove in the  removeBookingAtIndex
      dispatch(setCurBookings(newBookings));
      if (autoSetViewingIndex)
        dispatch(setViewingBookingIndex(newBookings.length - 1));
    }
    return true;
  };
};

/**
 * pass bookings?
 * @param submitAnyway
 */
const validateAllCurBookings = (submitAnyway?: boolean) => {
  return async (dispatch, getState): Promise<boolean> => {
    console.group('validateAllCurBookings');
    const curBookings = curBookingsBookingsSelector(getState());

    // clear error first
    let bookingsM = new Bookings(
      curBookings,
      true,
    ).clearAllErrorsAtAllIndexes() as Bookings;

    dispatch(curBookingsActions.setCurBookings(bookingsM.bookings));

    // dont pass found map
    bookingsM = bookingsM.validateAllBookingsAddErrorStatus();

    console.debug(`validateAllCurBookings: `, {
      bookingsM,
    });

    /* not continue if has empty or duplicates [start]  */
    // const hasEmptyOrDuplicates = bookingsM.hasEmptyOrDuplicates();
    // if (hasEmptyOrDuplicates) {
    //   dispatch(curBookingsActions.setCurBookings(bookingsM.bookings));

    //   // not continue if has empty or duplicates
    //   console.groupEnd();
    //   return false;
    // }
    /* not continue if has empty or duplicates [end]  */

    // fetch booking info first
    const bookingNos: string[] = [];
    let rowIndexes: number[] = [];
    bookingsM.bookingNos.forEach((bookingNo, i) => {
      if (!bookingNos.includes(bookingNo)) {
        bookingNos.push(bookingNo);
        rowIndexes.push(i);
      }
    });
    const foundMap = await dispatch(
      fetchBookingInfoIfNeeded(bookingNos, rowIndexes),
    );

    // let foundMap: {
    //   [bookingNo: string]: { found: boolean; notCanceled: boolean };
    // } = bookingIdToFoundAndNotCanceledSelector(getState());

    let canSubmit: boolean = bookingsM.validateFoundAndNotCanceled(
      foundMap,
    );

    if (!canSubmit && !submitAnyway) {
      //  update bookings (has updated errors)
      dispatch(curBookingsActions.setCurBookings(bookingsM.bookings)); // set error
      console.groupEnd();
      return false;
    }
    console.groupEnd();
    return true;
  };
};

/**
 * add new row
 */
const addNewBooking = (isSelectedAll?: boolean) => {
  return (dispatch, getState): Bookings | void => {
    const curBookings = curBookingsBookingsSelector(getState());
    if (!curBookings) return;
    const bookingsM = new Bookings(curBookings, true);
    // check if the first one is empty -> if empty -> add error but still allow adding the new row
    const attachments = availableOnlyAttachmentsWithThumbnailSelector(
      getState(),
    );
    const formTicket = ticketFormTicketSelector(getState());
    const commonPages = commonPagesSelector(getState());

    const emptyIndexes = bookingsM.getIndexesOfAllEmptyBookingNos();
    if (emptyIndexes && emptyIndexes.length) {
      dispatch(
        curBookingsActions.addBookingNoIsRequiredErrorToBookings(
          emptyIndexes,
        ),
      );
    }

    const withNewBooking = bookingsM.appendNewBooking(
      attachments,
      commonPages,
      formTicket?.bookingNo,
      formTicket?.isSplit,
      isSelectedAll,
    ) as Bookings;

    dispatch(
      curBookingsActions.setCurBookings(withNewBooking.bookings),
    );
    const newIndex = withNewBooking.length - 1;
    dispatch(
      curBookingsActions.validateBookingNoAtIndex(newIndex, true),
    );

    return withNewBooking;
  };
};

const reset = () => {
  return {
    type: curBookingsConstants.RESET,
  };
};

const removeFilesFromAllBookings = (partIds: string[]) => {
  return (dispatch, getState) => {
    const curBookings = curBookingsBookingsSelector(getState());
    if (!curBookings) return;
    const bookingsM = new Bookings(curBookings);
    const updated = bookingsM.removeFilesFromAllBookings(partIds);
    dispatch(curBookingsActions.setCurBookings(updated));
  };
};

export const curBookingsActions = {
  setCurBookings,
  addBookingNoIsRequiredErrorToBookings,
  updateBookingNoAtIndex,
  updateBookingNoAtIndexAndValidate,
  toggleSelectBooking,
  toggleSelectAllBookings,
  initCurBookings,
  removeSelectedBookings,
  removeBookingAtIndex,
  setViewingBookingIndex,
  updateFileSelectedAtViewingIndex,
  addNewBookingNo,
  addNewBooking,
  useAllBookingsFromEmail,
  addMultipleBookings,

  checkBottomBookingNoAndUpdateTop, // TODO: rename
  initCommonPages,
  validateBookingNoAtIndex,
  fetchBookingInfoIfNeeded,

  validateAllCurBookings,
  reset,

  removeFilesFromAllBookings,
};
